import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, ExclamationCircleIcon } from '@heroicons/react/24/outline';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import LoginShell from './LoginShell';
import { useAuth } from '../contexts/AuthContext';
import apiClient from '../services/apiClient';
import { ssoFehlerText } from './ssoFehler';

function SSOLanding() {
  const [searchParams] = useSearchParams();
  const { checkAuth } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    const state = searchParams.get('state');
    if (!token || !state) { setError('Der Anmeldelink ist unvollständig. Öffnen Sie den Zugang aus Ihrer Firma erneut oder melden Sie sich mit Ihrem CLAiRIS-Konto an.'); return; }
    apiClient.post('/sso/entry', { token, state })
      .then(async (res) => { await checkAuth(); navigate(res.data.redirectUrl || '/ris', { replace: true }); })
      .catch((err) => { setError(ssoFehlerText(err)); });
  }, [searchParams, checkAuth, navigate]);

  return (
    <LoginShell>
      <div className="login-form-wrap" aria-busy={!error}>
        {error ? <>
          <div className="login-result" role="alert">
            <ExclamationCircleIcon className="login-result-icon" aria-hidden="true" />
            <h1 id="auth-title">Anmeldung nicht möglich.</h1>
            <p className="login-intro">{error}</p>
          </div>
          <Link to="/login" className="login-submit"><span>Mit Konto anmelden</span><ArrowRightIcon aria-hidden="true" /></Link>
        </> : <>
          <div className="login-result" role="status">
            <div className="login-state-indicator" aria-hidden="true" />
            <h1 id="auth-title">Rechercheplatz öffnen</h1>
            <p className="login-intro">Ihre Anmeldung wird geprüft. Sie werden anschließend automatisch weitergeleitet.</p>
          </div>
        </>}
      </div>
    </LoginShell>
  );
}

export default SSOLanding;
